import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";

const Save = ({
  id = "btn-save",
  title,
  type = "default",
  onClick = () => {},
  icon = <CloseOutlined />,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.cancel");
  return (
    <Button
      className={`hover:opacity-70 ${className}`}
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(Save);
